// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page{width:100%;max-width:980px;margin:0 auto 0;padding:2px}", "",{"version":3,"sources":["webpack://./src/components/Page/Page.scss"],"names":[],"mappings":"AAAA,MACI,UAAA,CACA,eAAA,CACA,eAAA,CACA,WAAA","sourcesContent":[".page {\n    width: 100%;\n    max-width: 980px;\n    margin: 0 auto 0;\n    padding: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
